require('./').polyfill();